<template>
	<div>
		<el-dialog :title="$t('privateNetwork.delete')" :visible.sync="openStatus"
			class="cps-dialog-icon-line-height delete-eip-container"
			:close-on-click-modal="false" @close="doClose">
			<div class="align-in-middle">
				<p>{{ $t('sbw.help.confirmToDeleteSbw', [detailData ? detailData.name : '--'])}}</p>
				<br/>
				<el-checkbox v-model="checked">
					<p style="white-space: initial">{{$t('eip.help.knowAboutFee')}}</p>
				</el-checkbox>
			</div>
			<span slot="footer" class="dialog-footer">
			<el-button @click="doClose">{{ $t('detail.text.cancel') }}</el-button>
			<span style="margin-left:10px">
				<el-button @click="doConfirm"
				type="primary" :disabled="!checked || !!detailData.ipCount">
				{{ $t('detail.text.sure') }}
				</el-button>
				<el-tooltip effect="dark" style="margin-left:10px" placement="right"
				 	v-if="detailData.ipCount">
					<div slot="content" class="my-os-disk-tip">
						{{$t('sbw.help.deleteSbwTip')}}
					</div>
					<a><i class="jc-icon-question"></i></a>
				</el-tooltip>
			</span>
		</span>
		</el-dialog>
		<jcb-opt-protect :visible.sync="operationProtectVisible" :action-type="actionType"
			@success="onSuccess" @error="onError">
		</jcb-opt-protect>
	</div>
</template>

<script>
import operationProtect from '@/mixins/operationProject';
import { OperationConstant } from '@/common/Constants';

export default {
	mixins: [operationProtect],
	props: {
		dialogVisible: {
			type: Boolean,
			default: true,
		},
		// 传过来的SBW详情数据
		detailData: {
			type: Object
		},
	},
	data() {
		return {
			// 是否勾选checkbox提示
			checked: false,
			openStatus: false
		};
	},
	computed: {
		OperationConstant: () => OperationConstant,
	},
	watch: {
		dialogVisible(val) {
			this.openStatus = val;
		}
	},
	methods: {
		doClose() {
			this.$emit('ifDialogVisible', false);
			this.checked = false
		},
		doConfirm() {
			this.openOperationProtect(OperationConstant.DELETE_SBW, this.detailData)
		},
		deleteSbw(headers) {
			const params = {
				bandwidthPackageId: this.detailData.bandwidthPackageId,
				region: this.detailData.region,
				clientToken: Normal.getClientToken(),
			};
			Ajax.del('/api/cps/bandwidthPackages', params, { headers }).then(() => {
				this.$emit('refresh');
				this.$message.success(this.$t('privateNetInstance.operateSuccess'));
			}).finally(() => {
				this.doClose();
			});
		}
	}
};
</script>

<style lang="scss">
	.delete-eip-container{
		.jc-dialog__title{
			font-weight: 700
		}
		.align-in-middle{
			text-align: left;
			align-items: center;
			font-size: 14px;
			margin-left:50px
		}
		p{
			color: black;
		}
		.el-dialog.el-dialog--small{
			width: 500px;
		}
		.jc-dialog__body{
			margin-bottom:30px;
			margin-top: 50px;
		}

		label.jc-checkbox{
			max-width: 400px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/sbw/deleteSbw/DeleteSbw.vue